import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class FreeConsultationPopup extends Component {
  constructor() {
    super();
    this.state = {
      data_view:'',
      send_msg:','
    };
  }

componentDidMount(){
  this.get_user_free_consultation_view();
}
get_user_free_consultation_view(){
  let cutThis = this;
  var id = cutThis.props.id;
  var web_token = $('#web_token').val();
   var body = new FormData();
   body.append('id',id);
   body.append('web_token',web_token);
   body.append('function','view_free_consultation_data');
   var url      = '';
   if(window.location.host ==="localhost:3000"){
     url = "http://localhost/bylawsindia/php/user_free_consultation_url.php";
   }else{
     url = "/php/user_free_consultation_url.php";
   }
   axios({
        method: 'POST',
        url: url,
        data: body
    })
    .then(function (res) {
      var data = res.data;
      if(data['code']==1){
        var msg = data['msg'];
        cutThis.load_data(msg);
      }else{
        //window.location.href = '/';
      }

    })
    .catch(function (error) {
        console.log(error);
    });
}

load_data(msg){
  var data_view = [];
  var page_titlte = msg['subject_matter'];
  var write_flag = msg['write_flag'];
  $('#page_titlte').text(page_titlte);
  var message_data = msg['message'];
  var message_length = message_data.length;
  for(var i=0; i < message_length; i++){
    let user_type_class = 'receiver';
    let user_type = message_data[i]['user_type'];
    let added_date = message_data[i]['added_date'];
    let message_info = message_data[i]['message'];
    if(user_type==2){
      user_type_class = 'sender';
      added_date = message_data[i]['update_date'];
    }
    data_view.push(
      <div class={"message-content "+user_type_class}>
        <label for="">{added_date}</label>
        <div class="msg-block">
          <p>
            {message_info}
          </p>
        </div>
      </div>
    );
  }
  this.setState({data_view});

  var main_count = msg['main_count'];
  var added_count = msg['added_count'];
  var send_msg = [];
  if(write_flag==1 && added_count<main_count){
      send_msg.push(
        <div class="chat-footer">
        <div class="input-group md-form form-sm form-2 pl-0">
          <input class="form-control my-0 py-1 red-border" type="text" id="new_message" neme="new_message" placeholder="Write a message..." maxlength="250"/>
          <div class="input-group-append">
            <button class="btn input-group-text red lighten-3" id="basic-text1" onClick={this.send_new_message.bind(this,msg)}>
              <i class="fa fa-paper-plane" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    );
  }
  this.setState({send_msg});
}

send_new_message(msg){
  let cutThis         = this;
  var id              = cutThis.props.id;
  var new_message     = window.isNullAndUndef($("#new_message").val());
  var web_token       = window.isNullAndUndef($('#web_token').val());
  if(new_message && web_token && new_message.length<251){
    var body = new FormData();
    body.append('id',id);
    body.append('message',new_message);
    body.append('web_token',web_token);
    body.append('function','add_new_message_free_consulting_data');
    var url      = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/user_free_consultation_url.php";
    }else{
      url = "/php/user_free_consultation_url.php";
    }
    axios({
         method: 'POST',
         url: url,
         data: body
     })
     .then(function (res) {
        var data = res.data;
        if(data['code']){
          cutThis.get_user_free_consultation_view();
        }
     })
     .catch(function (error) {
         console.log(error);
     });
  }else{

  }

}

  render() {
    return (
        <div class="modal fade" id="myModal" role="dialog">
          <div class="modal-dialog popup_view_width">
            <div class="modal-content">
              <div class="modal-header">
              <h4 class="modal-title" id="page_titlte"></h4>
                <button type="button" class="close" data-dismiss="modal" onClick={this.props.close_popup_view}>&times;</button>
              </div>
              <div class="modal-body">


              <div class="chat-body">
               {this.state.data_view}
              </div>
              {this.state.send_msg}


              </div>
              {/*
              <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
              </div>
              */}
            </div>
          </div>
        </div>
    );
  }
}

export default FreeConsultationPopup;
